/** Bảng đặt / dỡ nội thất. Chọn loại rồi bấm vào ô lưới trên canvas. */
import { danhMucNoiThat, timLoaiNoiThat } from '../../core/noi-that.js';
import type { GameController } from '../game-controller.js';
import { dinhDangXu, styleNutChinh, styleNutPhu, stylePanel, useCapNhat } from '../dung-chung.js';

export function PanelNoiThat(props: {
  controller: GameController;
  cheDoDat: string | null;
  chonCheDoDat: (ma: string | null) => void;
  loiDat: string;
  baoDaDat: () => void;
}) {
  const { controller } = props;
  useCapNhat(controller);
  const { state, duLieu } = controller;
  const danhMuc = danhMucNoiThat(duLieu);

  return (
    <div style={stylePanel}>
      <h3 style={{ margin: '0 0 8px' }}>🪑 Nội thất</h3>
      <p style={{ fontSize: '12px', opacity: 0.85, margin: '0 0 8px' }}>
        Chọn món rồi bấm vào ô trống trong cửa hàng. Luôn giữ đường đi từ cửa đến quầy.
      </p>
      {danhMuc.map((loai) => {
        const mo = state.capCuaHang >= loai.capMo;
        const dangChon = props.cheDoDat === loai.ma;
        return (
          <button
            key={loai.ma}
            disabled={!mo}
            onClick={() => props.chonCheDoDat(dangChon ? null : loai.ma)}
            style={`${dangChon ? styleNutChinh : styleNutPhu} display: block; width: 100%; margin-bottom: 6px; text-align: left; opacity: ${mo ? 1 : 0.5};`}
          >
            {loai.ten} — {dinhDangXu(loai.gia)}
            {!mo && <span style={{ fontSize: '12px' }}> (mở từ cấp {loai.capMo})</span>}
          </button>
        );
      })}
      {props.cheDoDat && (
        <button onClick={() => props.chonCheDoDat(null)} style={`${styleNutPhu} width: 100%;`}>
          ✕ Hủy đặt ({timLoaiNoiThat(props.cheDoDat, duLieu).ten})
        </button>
      )}
      {props.loiDat && <p style={{ color: '#e08a8a', fontSize: '13px' }}>{props.loiDat}</p>}
      <h4 style={{ margin: '10px 0 6px', fontSize: '14px' }}>Đã đặt ({state.boCuc.length})</h4>
      <div style={{ maxHeight: '140px', overflowY: 'auto', fontSize: '13px' }}>
        {state.boCuc.map((m) => (
          <div
            key={m.uid}
            style={{ display: 'flex', gap: '6px', alignItems: 'center', padding: '3px 0' }}
          >
            <span style={{ flex: 1 }}>
              {timLoaiNoiThat(m.ma, duLieu).ten} — ô ({m.x}, {m.y})
            </span>
            <button
              onClick={() => {
                try {
                  controller.doNoiThat(m.uid);
                  props.baoDaDat();
                } catch (e) {
                  alert(e instanceof Error ? e.message : String(e));
                }
              }}
              style={{
                background: 'transparent',
                color: '#e08a8a',
                border: '1px solid #8a6a3a',
                borderRadius: '6px',
                padding: '2px 8px',
                cursor: 'pointer',
              }}
            >
              Dỡ
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
